import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

import AddressWithViewMapButton from './AddressWithViewMapButton'
import SummaryDataItem from './SummaryDataItem'

import { Place } from 'tripPlanner/types/common'
import { maybePlaceId } from 'tripPlanner/utils'

const LocationAndAddressWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(16)};
`

type Props = {
  place: Place
  placeTitle: string
}

const LocationAndAddressWithMap = (props: Props) => {
  const { place, placeTitle } = props
  return (
    <LocationAndAddressWrapper>
      <SummaryDataItem title={placeTitle} value={place.name} />
      {place.address && (
        <AddressWithViewMapButton
          placeId={maybePlaceId(place)}
          address={place.address}
        />
      )}
    </LocationAndAddressWrapper>
  )
}
export default LocationAndAddressWithMap
